import { Link } from "react-router-dom";
import { useFlags } from "@/lib/flags";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { useGraphite } from "@/components/Graphite";

// Links to the public legal pages (LegalPage.jsx), under the sign-in and sign-up forms and on those pages.
export function LegalLinks({ className }) {
  const link = "hover:text-foreground";
  const flags = useFlags();
  const graphite = useGraphite();  // Graphite's footer links: the display face at 14px
  return (
    <nav aria-label="Legal" className={cn("flex justify-center gap-4 text-xs text-muted-foreground",
      graphite && "font-display text-sm", className)}
      data-testid="legal-links">
      {flags.store && <Link to="/pricing" className={link}>Pricing</Link>}
      <Link to="/terms" className={link}>Terms</Link>
      <Link to="/privacy" className={link}>Privacy</Link>
      <Link to="/refunds" className={link}>Refunds</Link>
    </nav>
  );
}

// "I agree to the Terms and Privacy Policy", needed to sign up and to join a team. The links open in a new
// tab, so the form keeps what was typed.
export function TermsConsent({ id, checked, onChange }) {
  const link = "underline underline-offset-2 text-foreground";
  return (
    <div className="flex items-start gap-2.5">
      <Checkbox id={id} data-testid={id} checked={checked} onCheckedChange={(v) => onChange(v === true)} className="mt-0.5" />
      <Label htmlFor={id} className="text-sm font-normal leading-snug text-muted-foreground">
        I agree to the <a href="/terms" target="_blank" rel="noopener noreferrer" className={link}>Terms of Service</a> and
        the <a href="/privacy" target="_blank" rel="noopener noreferrer" className={link}>Privacy Policy</a>
      </Label>
    </div>
  );
}

export const TERMS_NEEDED = "Accept the Terms of Service and the Privacy Policy to continue.";
